import Filters from './filters'
import FiltersItem from './filters-item'
import SortCaret from './sort-caret'

Filters.install = Vue => {
  Vue.component(Filters.name, Filters)
}

FiltersItem.install = Vue => {
  Vue.component(FiltersItem.name, FiltersItem)
}

SortCaret.install = Vue => {
  Vue.component(SortCaret.name, SortCaret)
}

export {Filters, FiltersItem, SortCaret}



// WEBPACK FOOTER //
// ./src/components/filters/index.js